import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: {
    account: "string";
    departmentName: "string";
    employeeCode: "string";
    name: "string";
    positionName: "string";
  } | null;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: null,
};

const getDirectionManagerSlice = createSlice({
  name: "getDirectionManager",
  initialState,
  reducers: {
    getDirectionManagerStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getDirectionManagerSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getDirectionManagerFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetDirectionManager: () => {
      return { ...initialState };
    },
  },
});

export const {
  getDirectionManagerStart,
  getDirectionManagerSuccess,
  getDirectionManagerFailed,
  resetDirectionManager,
} = getDirectionManagerSlice.actions;

export default getDirectionManagerSlice.reducer;
